function validateHome(form) {
  return {
    ...(!form.account && {
      account:
        'Hmm, looks like we’re missing something. Let us know how you want to apply then try again.'
    })
  };
}

export { validateHome as validate };
